import { WorkplaceStatus } from '@cpce/database/enums';
import { createFileRoute } from '@tanstack/react-router';
import { ChevronDown } from 'lucide-react';
import { useUserWorkplace } from '@/api/users/users.queries';
import { Badge, BadgeColor } from '@/components/Badge';
import { CardWithTitle } from '@/components/CardWithTitle';
import { FieldsGrid } from '@/components/FieldsGrid';
import { StickyHeaderPage } from '@/components/StickyHeaderPage';
import { Spinner } from '@/components/shadcn/Spinner';

export const Route = createFileRoute('/account/lieu-de-travail/$id')({
  component: WorkplaceDetailsPage,
});

function WorkplaceDetailsPage() {
  const { id } = Route.useParams();
  const workplaceId = Number.parseInt(id, 10);
  const { data: workplace, isLoading } = useUserWorkplace(workplaceId);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner className="size-8" />
      </div>
    );
  }

  if (!workplace) {
    return (
      <div className="p-6">
        <p className="text-gray-500">Lieu de travail introuvable</p>
      </div>
    );
  }

  const isActive = workplace.status === WorkplaceStatus.Active;

  return (
    <StickyHeaderPage
      pathLink={[
        { label: 'Lieu de travail', navigate: { to: '/account/lieu-de-travail' } },
        { label: workplace.nomLieu },
      ]}
      title={workplace.nomLieu}
      topRightActions={
        <div className="flex flex-col items-end gap-1">
          <span className="text-xs text-gray-500">Statut du lieu</span>
          <Badge
            color={isActive ? BadgeColor.GREEN : BadgeColor.GRAY}
            className="flex items-center gap-1 cursor-default"
          >
            {isActive ? 'Actif' : 'Inactif'}
            <ChevronDown className="size-3 opacity-50" />
          </Badge>
        </div>
      }
      contentClassName="flex flex-col gap-4"
    >
      <CardWithTitle title="Informations générales">
        <FieldsGrid
          fields={[
            { title: 'Nom', value: workplace.nomLieu },
            { title: 'Code postal', value: workplace.codePostal },
            { title: 'Adresse', value: workplace.adresse },
            { title: 'Ville', value: workplace.ville },
            { title: 'SIREN', value: workplace.siren },
          ]}
        />
      </CardWithTitle>

      <CardWithTitle title="Coordonnées">
        <FieldsGrid
          fields={[
            { title: 'Téléphone', value: workplace.telephone },
            { title: 'Email', value: workplace.email },
            { title: 'Responsable du site', value: workplace.manager },
          ]}
        />
      </CardWithTitle>
    </StickyHeaderPage>
  );
}
